"use strict";

var _require = require("../converter"),
    convertToCustomFormat = _require.convertToCustomFormat;

var resultToWebMethodPayload = function resultToWebMethodPayload(resultObj, replacer) {
  var result = replacer ? JSON.parse(JSON.stringify(resultObj, replacer)) : convertToCustomFormat(resultObj);
  return result === undefined ? {} : {
    result: result
  };
};

var exceptionToWebMethodPayload = function exceptionToWebMethodPayload(error) {
  var messageProcessor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (arg) {
    return arg;
  };
  var stackProcessor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return "";
  };
  var result = error instanceof Error ? {
    message: messageProcessor(error.message),
    name: error.name,
    stack: stackProcessor(error.stack),
    code: error.code,
    _elementoryError: true
  } : error;
  return {
    result: result,
    exception: true
  };
};

module.exports = {
  resultToWebMethodPayload: resultToWebMethodPayload,
  exceptionToWebMethodPayload: exceptionToWebMethodPayload
};